import { render } from "./distributorwisedealerstock_form.vue?vue&type=template&id=81eabd3c&scoped=true"
import script from "./distributorwisedealerstock_form.vue?vue&type=script&lang=js"
export * from "./distributorwisedealerstock_form.vue?vue&type=script&lang=js"

import "./distributorwisedealerstock_form.vue?vue&type=style&index=0&id=81eabd3c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81eabd3c"]])

export default __exports__